import Certificates from "./Certificates";

export default Certificates;
